<template>
    <div>
      <component v-bind:is="currentNav"></component>
    </div>
</template>

<script>
  import Nav from '@/components/Nav.vue';
  import NavDetai from '@/components/NavDetai.vue';
    export default {
        name: "changeNav",
      components:{
        Nav,
        NavDetai
      },
      data(){
          return{
            currentNav:"Nav"
          }
      },
      mounted(){
        window.addEventListener("scroll",this.changeNavbg);
      },
      destroyed(){
        window.removeEventListener("scroll",this.changeNavbg);
      },
      methods:{
        changeNavbg(){
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          scrollTop < 100 ?  this.currentNav ="Nav" : this.currentNav = "NavDetai"
        }
      }
    }
</script>

<style scoped>

</style>
